<template>
  <div style="padding-bottom: 60px" class="body-s">
    <van-nav-bar title="搜索测评结果" left-text="返回" left-arrow @click-left="onClickLeft" />
    <van-search v-model="keyword" :disabled="search_loading" placeholder="请输入搜索关键词" autofocus @search="onSearch()" />
    <div class="res-list">
      <van-tabs v-model="active">
        <van-tab title="行业" name="industry">
          <van-loading
            style="text-align: center;min-height: 70px;display: flex;justify-content: center;align-items: center;"
            v-if="search_loading" vertical>搜索中...</van-loading>
          <van-empty description="暂无数据" v-show="industry.length < 1" />
          <dl class="type-list">
            <dd v-for="item in industry" :key="item.id" @click="showRank(item)">
              <div class="tit"><van-icon name="award-o" /> {{ item.title }} </div>
              <div class="tool">
                <span class="num">{{ item.count }}家企业入选</span>
                <span class="right">查看榜单 <van-icon name="arrow" /></span>
              </div>
            </dd>
          </dl>
        </van-tab>
        <van-tab title="企业" name="company">
          <van-loading
            style="text-align: center;min-height: 70px;display: flex;justify-content: center;align-items: center;"
            v-if="search_loading" vertical>搜索中...</van-loading>
          <van-empty description="暂无数据" v-show="company.length < 1" />
          <dl class="type-list">
            <dd v-for="item in company" :key="item.company_name">
              <router-link v-if="item.company_id" :to="{ name: 'Hall', query: { id: item.company_id } }"
                target="_blank">
                <div class="tit"><van-icon name="hotel-o" /> {{ item.company_name }}</div>
                <div class="tool">
                  <span class="num">累计奖项：{{ item.count }}</span>
                  <span class="right">查看详情 <van-icon name="arrow" /></span>
                </div>
              </router-link>
              <router-link v-else :to="{ name: 'HallRef', query: { id: item.id } }" target="_blank">
                <div class="tit"><van-icon name="hotel-o" /> {{ item.company_name }}</div>
                <div class="tool">
                  <span class="num">累计奖项：{{ item.count }}</span>
                  <span class="right">查看详情 <van-icon name="arrow" /></span>
                </div>
              </router-link>
            </dd>
          </dl>
        </van-tab>
      </van-tabs>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '70%' }">
      <div class="rank-p pd-10">
        <div class="tit show-tit-gold">{{ rankTitle }}</div>
        <div>
          <ul class="data-ul data-list" v-if="rankList.rank.length > 0">
            <li v-for="item in rankList.rank" :key="item.id">
              <div class="box-rank-data van-clearfix">
                <div>
                  <template>
                    <router-link v-if='item.company' :to="{ name: 'Hall', query: { id: item.company_id } }"
                      target="_blank">
                      <van-image :src="item.company.logo" class="company-logo" fit="contain" lazy-load>
                        <template v-slot:error>无企业LOGO</template>
                      </van-image>
                    </router-link>
                    <router-link v-else :to="{ name: 'HallRef', query: { id: item.id } }" target="_blank">
                      <van-image class="company-logo" fit="contain" lazy-load>
                        <template v-slot:error>无企业LOGO</template>
                      </van-image>
                    </router-link>
                  </template>
                </div>
                <div>
                  <div class="company-text">
                    <router-link v-if="item.company" :to="{ name: 'Hall', query: { id: item.company_id } }"
                      target="_blank">
                      {{ item.company_name || item.company.CompanyName }}
                    </router-link>
                    <router-link v-else :to="{ name: 'HallRef', query: { id: item.id } }" target="_blank">
                      {{ item.company_name }}
                    </router-link>
                  </div>
                  <div class="tag-val-box van-clearfix">
                    <div>
                      <div class="val-tips rank-top">{{ item.show_sort }}</div>
                      <div class="val-tips-sm">TOP</div>
                    </div>

                    <div>
                      <div class="val-tips">{{ item.unit_val }}{{ rankList.interpretive_unit }}</div>
                      <div class="val-tips-sm">{{ rankList.interpretive_prefix }}</div>
                    </div>

                    <div>
                      <div class="val-tips rank-brand">{{ item.rank_brand || "-" }}</div>
                      <div class="val-tips-sm">品牌</div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </van-popup>
  </div>
</template>


<style scoped>
.pd-10 {
  padding: 10px;
}

.center {
  text-align: center;
}

.location-text {
  color: rgba(232, 191, 162, 1);
  margin-left: 5px;
}

.body-s {
  min-height: 90vh;
  background-color: #1f1102;
}

.res-list {
  margin: 10px;
  padding: 10px;
  min-height: 200px;
  background: #fff;
  box-sizing: border-box;
}

.type-list {
  padding: 10px;
}

.type-list>dd {
  margin: 0;
  margin-bottom: 20px;
  background: linear-gradient(1deg, #FFEDDF 0%, #FFEDDF 2%, #FFF4EA 100%);
  padding: 15px 10px;
  border-radius: 2px;
}

.type-list .tit {
  color: #A05F1F;
  font-size: 14px;
  font-weight: bold;
}

.type-list .num {
  color: #886254;
  font-size: 12px;
  padding-left: 1rem;
}

.type-list .right {
  float: right;
  color: #ecb475;
  font-size: 12px;
}

.type-list .tool {
  margin-top: 5px;
}

.rank-p .tit {
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  padding: 15px 0;
  position: sticky;
  z-index: 2;
  background-color: #ffffff;
  top: 0;
}

.data-list {
  margin-top: 20px;
}

.data-list li {
  background: linear-gradient(89deg, #FFF9F4 0%, #FFF2E6 100%);
  min-height: 120px;
  margin-bottom: 20px;
  position: relative;
  padding: 15px 10px;
  box-sizing: border-box;
  border-radius: 3px;
  overflow: hidden;
}

.data-list li::after {
  content: "\e660";
  position: absolute;
  top: 18px;
  right: 10px;
  display: inline-block;
  font: normal normal normal 14px/1 'vant-icon';
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  color: rgba(232, 191, 162, 1);
}

.box-rank-data>div {
  float: left;
}

.box-rank-data>div:nth-child(1) {
  width: 100px;
}

.box-rank-data>div:nth-child(2) {
  width: calc(100% - 105px);
  margin-left: 5px;
  position: relative;
}

.box-rank-data>div:nth-child(2)::before {
  content: " ";
  background: url("~@/assets/images/bg_rank.png") no-repeat;
  background-size: contain;
  height: 170px;
  width: 115px;
  position: absolute;
  top: -10px;
  right: -10px;
}


.box-rank-data .company-logo {
  width: 90px;
  height: 65px;
  display: block;
  background: white;
  object-fit: contain;
  border-radius: 3px;
}


.box-rank-data .company-text,
.box-rank-data .company-text a {
  color: #5D2811;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  position: relative;
  z-index: 1;
}

.tag-val-box>div {
  float: left;
  margin-right: 5px;
  margin-top: 10px;
  background: #FFEDDF;
  border-radius: 3px;
  text-align: center;
  box-sizing: border-box;
  padding: 5px;
  font-size: 12px;
}


.tag-val-box>div:last-child {
  margin-right: 0;
}

.tag-val-box>div:nth-child(1) {
  width: 50px;
}

.tag-val-box>div:nth-child(2) {
  width: 100px;
}

.tag-val-box>div:nth-child(3) {
  width: calc(100% - (5px * 2) - 100px - 50px);
}

.val-tips {
  font-size: 12px;
  color: #DF4239;
  height: 24px;
  line-height: 24px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.val-tips.rank-brand {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}


.val-tips-sm {
  color: #937B70;
  margin-top: 5px;
  height: 16px;
  line-height: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;

}

.show-tit-gold::after {
  position: absolute;
  content: '';
  width: 70px;
  height: 5px;
  display: inline-block;
  background: linear-gradient(90deg, #F04035 0%, rgba(240, 64, 3, 0.2) 80%, #FEF4EB 100%);
  bottom: 4px;
  left: 0px;
  z-index: -1;
}
</style>
<script>
import { nextTick } from 'process';

export default {
  name: "Search",
  metaInfo: {
    title: '搜索 @优采云大数据服务平台',
    htmlAttrs: {
      lang: 'zh-CN',
      keyword: '优采云，大数据，云服务，报告',
      amp: true
    }
  },
  data() {
    return {
      keyword: '',
      active: "industry",
      show: false,
      industry: [],
      company: [],
      search_loading: false,
      rankList: {
        rank: []
      },
      rankTitle: '区域测评报告（行业）',
    }
  },
  mounted() {

  },
  methods: {
    onRefCompany() {
      this.$dialog.alert({
        message: '通过优采企业认证后可管理该企业信息。如果您已经认证，请耐心等待数据更新',
      });
    },
    onClickLeft() {
      if (window.WeixinJSBridge) {
        this.$router.push("/")
      } else {
        // 在其他浏览器中
        window.close()
      }
    },
    onSearch() {
      this.search_loading = true
      this.$axios.post(this.$apiconfg.search, { keyword: this.keyword }).then(({ data }) => {
        if (data.code === 1) {
          this.industry = data.data.industry
          this.company = data.data.company

          nextTick(() => {
            //仅有行业数据
            if (this.industry.length > 0 && this.company.length == 0) {
              if (this.active == 'industry') {
                return false;
              }
              this.active = 'industry'
              this.$toast({
                message: '仅行业有搜索结果，已切换',
                position: 'bottom',
              });
            }
            //仅有企业数据
            if (this.industry.length == 0 && this.company.length > 0) {
              if (this.active == 'company') {
                return false;
              }
              this.active = 'company'
              this.$toast({
                message: '仅企业有搜索结果，已切换',
                position: 'bottom',
              });
            }
          })

        }
        this.search_loading = false
      })
    },
    showRank(item) {
      this.rankTitle = item.title
      this.rankList = item
      this.show = true
      console.log(item)
    }
  },
}
</script>